
import { motion } from "framer-motion";
import React from "react";

interface DueDiligenceSectionProps {
  title: string;
  children: React.ReactNode;
}

const DueDiligenceSection = ({
  title,
  children
}: DueDiligenceSectionProps) => (
  <motion.div 
    initial={{ opacity: 0, y: 20 }} 
    whileInView={{ opacity: 1, y: 0 }} 
    viewport={{ once: true }}
    transition={{ duration: 0.5 }} 
    className="mb-8 bg-white rounded-xl shadow-md border border-[#D3DCE4] hover:shadow-lg transition-all duration-300"
  >
    <div className="p-8">
      <h2 className="text-xl font-semibold text-corporate-primary-100 mb-6 flex items-center">
        <span className="bg-corporate-primary-25 text-corporate-primary-100 rounded-full w-8 h-8 inline-flex items-center justify-center mr-3">
          {title.split('.')[0]}
        </span>
        <span>{title.split('.')[1]}</span>
      </h2>
      <div className="text-corporate-neutral-75">
        {children}
      </div>
    </div>
  </motion.div>
);

export default DueDiligenceSection;
